import { defineMessages } from 'react-intl';

const joinPagePrefix = 'front_join';

export const JoinPageTranslations = defineMessages({
  submittedTitle: {
    id: `${joinPagePrefix}_submittedTitle`,
    defaultMessage: 'Application form submitted',
  },
  submittedSubtitle: {
    id: `${joinPagePrefix}_submittedSubtitle`,
    defaultMessage: 'Thanks for having sent your application',
  },
  pageTitle: {
    id: `${joinPagePrefix}_pageTitle`,
    defaultMessage: 'Are you a photographer ?',
  },
  pageTitleEdit: {
    id: `${joinPagePrefix}_pageTitleEdit`,
    defaultMessage: 'Your application ?',
  },
  personalInfosTitle: {
    id: `${joinPagePrefix}_personalInfosTitle`,
    defaultMessage: 'Personal informations',
  },
  companyInfosTitle: {
    id: `${joinPagePrefix}_companyInfosTitle`,
    defaultMessage: 'Your status',
  },
  specialityListTitle: {
    id: `${joinPagePrefix}_specialityListTitle`,
    defaultMessage: 'Your specialities',
  },
  availabilityTitle: {
    id: `${joinPagePrefix}_availabilityTitle`,
    defaultMessage: 'Your availabilities',
  },
  transportationSubtitle: {
    id: `${joinPagePrefix}_transportationSubtitle`,
    defaultMessage: 'Transportation',
  },
  availabilitySubtitle: {
    id: `${joinPagePrefix}_availabilitySubtitle`,
    defaultMessage: 'Availabilities',
  },
  localisationTitle: {
    id: `${joinPagePrefix}_localisationTitle`,
    defaultMessage: 'Your location',
  },
  localisationSubtitle: {
    id: `${joinPagePrefix}_localisationSubtitle`,
    defaultMessage: 'Vos zones',
  },
  localisationSubtitle1: {
    id: `${joinPagePrefix}_localisationSubtitle1`,
    defaultMessage: 'Select your zones once your address is recognised',
  },
  localisationSubtitle2: {
    id: `${joinPagePrefix}_localisationSubtitle2`,
    defaultMessage:
      'Please choose carefully your zones depending on your address and transportation',
  },
  localisationSubTitle: {
    id: `${joinPagePrefix}_localisationSubTitle`,
    defaultMessage: 'Click directly on the map to select your zones',
  },
  materialTitle: {
    id: `${joinPagePrefix}_materialTitle`,
    defaultMessage: 'Your equipment',
  },
  materialSubtitle: {
    id: `${joinPagePrefix}_materialSubtitle`,
    defaultMessage: 'What kind of equipment ?',
  },
  materialInfos: {
    id: `${joinPagePrefix}_materialInfos`,
    defaultMessage:
      'Nous acceptons uniquement un matériel professionnel de haute qualité. Il est primordial de posséder le matériel ci-dessous, sinon votre candidature ne sera pas retenue.',
  },
  materialInfosSubtitle1: {
    id: `${joinPagePrefix}_materialInfosSubtitle1`,
    defaultMessage: 'Objectif',
  },
  materialInfosSubtitle2: {
    id: `${joinPagePrefix}_materialInfosSubtitle2`,
    defaultMessage: 'Boitier',
  },
  materialInfosSubtitle3: {
    id: `${joinPagePrefix}_materialInfosSubtitle3`,
    defaultMessage: 'Trépied',
  },
  materialInfosDescription1: {
    id: `${joinPagePrefix}_materialInfosDescription1`,
    defaultMessage:
      'Ultra grand angle tels que le Canon 16-35mm ou le Nikon 14-24mm (ou équivalent). Un objectif 24-70mm n’est pas considéré comme un ultra grand angle et les fisheyes ne nous servent pas non plus). Pour les détails, 50mm et / ou 24-70mm.',
  },
  materialInfosDescription2: {
    id: `${joinPagePrefix}_materialInfosDescription2`,
    defaultMessage: 'Plein format ou APS-C (gamme professionnelle).',
  },
  materialInfosDescription3: {
    id: `${joinPagePrefix}_materialInfosDescription3`,
    defaultMessage: 'Solide avec niveau à bulle.',
  },
  realisationLinksTitle: {
    id: `${joinPagePrefix}_realisationLinksTitle`,
    defaultMessage: 'Vos réalisations',
  },
  realisationLinksAddLink: {
    id: `${joinPagePrefix}_realisationLinksAddLink`,
    defaultMessage: 'Ajouter un lien',
  },
  realisationLinksRemoveLink: {
    id: `${joinPagePrefix}_realisationLinksRemoveLink`,
    defaultMessage: 'Supprimer ce lien',
  },
});
